
/**
 * 코스 난이도 (자유 텍스트 입력)
 * @minLength 1
 * @maxLength 50
 */
export type CourseLevel = string;
